"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visit = void 0;
const MARKS = {
    PERMANENT: 'PERMANENT',
    TEMPORARY: 'TEMPORARY',
};
const visit = (node, marks, deps, callback) => {
    const mark = marks.get(node);
    if (mark === MARKS.PERMANENT) {
        return;
    }
    if (mark === MARKS.TEMPORARY) {
        throw new Error('Cyclic dependency');
    }
    marks.set(node, MARKS.TEMPORARY);
    if (deps.has(node)) {
        for (const dep of deps.get(node)) {
            (0, exports.visit)(dep, marks, deps, callback);
        }
    }
    marks.set(node, MARKS.PERMANENT);
    callback(node);
};
exports.visit = visit;
//# sourceMappingURL=visit.js.map